import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';

// A tab left open across a deploy keeps running the old code, so fixes seem not to work. This
// checks the live page every few minutes (and when the tab comes back into view) and, when the
// app's main bundle has changed, offers a reload. It never reloads by itself — a recording or an
// unsaved edit might be in progress.

const currentBundle = () => (document.querySelector('script[src*="/assets/main-"]') as HTMLScriptElement | null)?.src.match(/main-[\w-]+\.js/)?.[0] || null;

export const NewVersionNotice: React.FC<{ language: string }> = ({ language }) => {
    const vn = language === 'vietnamese';
    const [stale, setStale] = useState(false);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const mine = currentBundle();
        if (!mine) return; // dev server: no hashed bundle to compare
        let stopped = false;
        const check = async () => {
            if (stopped || document.visibilityState !== 'visible') return;
            try {
                const html = await (await fetch('/', { cache: 'no-store' })).text();
                const live = html.match(/main-[\w-]+\.js/)?.[0];
                if (live && live !== mine) { setStale(true); setHidden(false); }
            } catch { /* offline — try again later */ }
        };
        const t = setInterval(check, 5 * 60 * 1000);
        document.addEventListener('visibilitychange', check);
        return () => { stopped = true; clearInterval(t); document.removeEventListener('visibilitychange', check); };
    }, []);

    if (!stale || hidden) return null;
    return (
        <div className="fixed bottom-4 left-4 z-[400] flex items-center gap-2 pl-3 pr-1.5 py-1.5 rounded-xl bg-gray-900 text-white shadow-xl text-xs print:hidden">
            <span>{vn ? 'Có bản StudyBoard mới.' : 'A new StudyBoard version is available.'}</span>
            <button onClick={() => window.location.reload()} className="flex items-center gap-1 px-2 py-1 rounded-lg bg-amber-500 hover:bg-amber-600 font-bold">
                <RefreshCw size={11} />{vn ? 'Tải lại' : 'Reload'}
            </button>
            <button onClick={() => setHidden(true)} title={vn ? 'Để sau' : 'Later'} className="p-1 rounded-lg hover:bg-white/10"><X size={12} /></button>
        </div>
    );
};
